import Link from 'next/link';

import { ClaudeLogoIcon, OpenAILogoIcon } from '@/components/icons/svgs';

import { APP_ROUTES } from '@/shared/constants/navigation';

export const HeroSection = () => {
	return (
		<section className="landing-width mb-4 flex w-full flex-col items-center text-center md:mb-5">
			<h1 className="landing-heading mt-8 w-full text-balance !bg-none !text-[32px] !text-primary tracking-tight md:mt-0 md:!text-[48px]">
				The hiring tool built for the AI era.
			</h1>
			<p className="mt-5 max-w-3xl text-pretty text-base leading-relaxed text-[hsl(215_20%_38%)] md:mt-6 md:max-w-xl md:text-[1.375rem] md:leading-8">
				Binary is the new age ATS to create delightful hiring forms, screen candidates and
				manage your entire hiring process.
			</p>
			<Link
				href={APP_ROUTES.MCP}
				className="relative z-10 mt-6 flex items-center rounded-full bg-white py-1 px-3 transition-colors hover:bg-accent md:mt-7"
			>
				<p className="flex items-center gap-1 text-xs font-medium text-primary/80 md:text-sm">
					<span>Works with</span>
					<span className="inline-flex items-center gap-1">
						<ClaudeLogoIcon className="size-4 h-lh shrink-0" />
						Claude,
					</span>
					<span className="inline-flex items-center gap-1">
						<OpenAILogoIcon className="size-4 h-lh shrink-0 text-primary" />
						ChatGPT
					</span>
					<span>and more</span>
				</p>
			</Link>
		</section>
	);
};
